module.exports = __webpack_public_path__ + "static/12-7a36ddbe69b18b48abdb62cfb34b979f.png";